module.exports = __webpack_public_path__ + "img/tlogo.878e759c.png";